import { PropsWithChildren, useContext } from 'react'
import { HotelContext, HotelContextProvider } from '../contexts/HotelContext'
import { Box, Typography } from '@mui/material'
import { DeviceContextProvider } from '../contexts/DeviceContext'

export const HotelLayoutContent = ({ children }: PropsWithChildren) => {
  const { hotel } = useContext(HotelContext)

  return (
    <>
      <Box textAlign="center" mt={1} sx={{ opacity: 0.8 }}>
        <Typography color={(theme) => theme.palette.text.secondary} fontSize="1rem">
          {hotel.hotelName}
        </Typography>
      </Box>
      {children}
    </>
  )
}

export const HotelLayout = (props: PropsWithChildren) => {
  return (
    <HotelContextProvider>
      <HotelLayoutContent {...props} />
    </HotelContextProvider>
  )
}

export const HotelDeviceLayout = (props: PropsWithChildren) => {
  return (
    <HotelContextProvider>
      <DeviceContextProvider>
        <HotelLayoutContent {...props} />
      </DeviceContextProvider>
    </HotelContextProvider>
  )
}
